import React from 'react';
import { NumericalColumn, StringColumn, CustomColumn } from 'baseui/data-table';
import dayjs from 'dayjs';
import { EMPTY_NUMBER, EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	transactionId: 'tid',
	zupeePayoutStatus: 'zupeePayoutStatus',
	createdAt: 'timestamp',
	amount: 'amount',
	name: 'name',
	merchant: 'merchant',
	referenceId: 'referenceId',
	utr: 'utr',
	pgFailureReason: 'pgFailureReason',
	pgStatus: 'pgStatus'
};

export const columnConfigs = [
	NumericalColumn({
		title: 'Transaction Id',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.transactionId] || EMPTY_NUMBER
	}),
	StringColumn({
		title: 'Reference Id',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.merchant][COL_NAMES.referenceId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'UTR Number',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.merchant][COL_NAMES.utr] || EMPTY_STRING
	}),
	NumericalColumn({
		title: 'Amount (₹)',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.amount] || EMPTY_NUMBER
	}),
	StringColumn({
		title: 'Merchant',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.merchant][COL_NAMES.name] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Zupee Status',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.zupeePayoutStatus] || EMPTY_STRING
	}),
	StringColumn({
		title: 'PG Status',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.pgStatus] || EMPTY_STRING
	}),
	CustomColumn({
		title: 'PG Failure Reason',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.pgFailureReason] || EMPTY_STRING,
		renderCell: (params: any) => {
			const { value } = params;
			let compressPgFailureReason = '';
			if (value.length > 30) {
				compressPgFailureReason = `${value.substr(0, 30)}...`;
			} else {
				compressPgFailureReason = value;
			}
			return <div title={value}>{compressPgFailureReason}</div>;
		}
	}),
	StringColumn({
		title: 'Created At',
		maxWidth: 200,
		mapDataToValue: (data: any) =>
			data[COL_NAMES.createdAt] ? dayjs(new Date(data[COL_NAMES.createdAt])).format('YYYY-MM-DD hh:mm A') : EMPTY_STRING
	})
];
